import ListaProtocolo from '../componentes/ListaProtocolo.vue'
// import FormProtocolo from '../componentes/FormProtocolo.vue'

const routes = [
    /*...route('/guardar-protocolo', FormProtocolo, {
        Auth: true,
        ///req_admin: true
     }),*/
     ...route('/lista-protocolos', ListaProtocolo, {
       Auth: true,
       //req_admin: true
    }),]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes